import { Link } from 'react-router-dom';

export default function LegalPlaceholderPage({ title }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-neutral-100 text-neutral-800">
      <h1 className="text-2xl font-semibold tracking-tight mb-3 text-center">{title}</h1>
      <p className="text-neutral-500 text-center mb-10">Page en cours de rédaction</p>
      <Link
        to="/"
        className="text-sm text-neutral-600 underline underline-offset-2 hover:text-neutral-900 transition-colors"
      >
        ← Retour à l&apos;accueil
      </Link>
    </div>
  );
}
